import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const SmartOptIn = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 128 128" data-test="smartopt-in" {...props}>
    <path
      d="M12.2321 64.2C12.2321 77.7791 17.6264 90.802 27.2283 100.404C36.8301 110.006 49.8531 115.4 63.4322 115.4C77.0112 115.4 90.0342 110.006 99.636 100.404C109.238 90.802 114.632 77.7791 114.632 64.2C114.632 50.6209 109.238 37.598 99.636 27.9961C90.0342 18.3943 77.0112 13 63.4322 13C49.8531 13 36.8301 18.3943 27.2283 27.9961C17.6264 37.598 12.2321 50.6209 12.2321 64.2V64.2Z"
      fill="#E6FBFF"
    />
    <path
      d="M44.2321 32.3949C44.232 31.7127 44.3662 31.0371 44.6272 30.4068C44.8881 29.7764 45.2707 29.2037 45.7531 28.7212C46.2354 28.2387 46.8081 27.856 47.4383 27.5949C48.0686 27.3338 48.7442 27.1994 49.4264 27.1994H76.364C77.0461 27.1992 77.7217 27.3335 78.3519 27.5944C78.9822 27.8554 79.5549 28.238 80.0372 28.7204C80.5196 29.2027 80.9022 29.7754 81.1632 30.4057C81.4242 31.036 81.5584 31.7115 81.5582 32.3936V90.1664C81.5582 90.8485 81.4239 91.5239 81.1628 92.154C80.9018 92.7841 80.5191 93.3566 80.0368 93.8389C79.5544 94.3211 78.9818 94.7036 78.3516 94.9645C77.7215 95.2254 77.046 95.3596 76.364 95.3594H49.4264C48.0489 95.3591 46.7279 94.8117 45.7539 93.8377C44.7798 92.8636 44.2325 91.5427 44.2321 90.1652V32.3949Z"
      fill="white"
    />
    <path
      d="M52.1429 104.285C52.1429 104.82 53.2757 105.333 55.292 105.711C57.3084 106.089 60.0432 106.301 62.8949 106.301C65.7465 106.301 68.4813 106.089 70.4977 105.711C72.5141 105.333 73.6469 104.82 73.6469 104.285C73.6469 103.751 72.5141 103.238 70.4977 102.86C68.4813 102.482 65.7465 102.269 62.8949 102.269C60.0432 102.269 57.3084 102.482 55.292 102.86C53.2757 103.238 52.1429 103.751 52.1429 104.285Z"
      fill="#0B3251"
    />
    <path
      d="M44.2321 32.3949C44.232 31.7127 44.3662 31.0371 44.6272 30.4068C44.8881 29.7764 45.2707 29.2037 45.7531 28.7212C46.2354 28.2387 46.8081 27.856 47.4383 27.5949C48.0686 27.3338 48.7442 27.1994 49.4264 27.1994H76.364C77.0461 27.1992 77.7217 27.3335 78.3519 27.5944C78.9822 27.8554 79.5549 28.238 80.0372 28.7204C80.5196 29.2027 80.9022 29.7754 81.1632 30.4057C81.4242 31.036 81.5584 31.7115 81.5582 32.3936V90.1664C81.5582 90.8485 81.4239 91.5239 81.1628 92.154C80.9018 92.7841 80.5191 93.3566 80.0368 93.8389C79.5544 94.3211 78.9818 94.7036 78.3516 94.9645C77.7215 95.2254 77.046 95.3596 76.364 95.3594H49.4264C48.0489 95.3591 46.7279 94.8117 45.7539 93.8377C44.7798 92.8636 44.2325 91.5427 44.2321 90.1652V32.3949Z"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M47.4777 36.9375H78.3129V84.8121H47.4777V36.9375Z" fill="#34C3F2" />
    <path d="M47.4777 62.7961L73.3375 36.9375H47.4777V62.7961Z" fill="white" />
    <path
      d="M47.4777 36.9375H78.3129V84.8121H47.4777V36.9375Z"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.2708 32.0685H70.1976"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.4057 32.0045C56.4217 32.0069 56.4364 32.0146 56.4473 32.0265C56.4583 32.0384 56.4648 32.0537 56.4658 32.0698C56.4643 32.0863 56.4568 32.1016 56.4448 32.1129C56.4328 32.1242 56.417 32.1307 56.4005 32.1313C56.3836 32.1313 56.3673 32.1245 56.3553 32.1125C56.3433 32.1005 56.3365 32.0842 56.3365 32.0673C56.3365 32.0503 56.3433 32.034 56.3553 32.022C56.3673 32.01 56.3836 32.0033 56.4005 32.0033M56.4005 30.7233C56.0441 30.7233 55.7022 30.8649 55.4502 31.1169C55.1981 31.369 55.0565 31.7108 55.0565 32.0673C55.0565 32.4237 55.1981 32.7656 55.4502 33.0176C55.7022 33.2697 56.0441 33.4113 56.4005 33.4113C56.757 33.4113 57.0989 33.2697 57.3509 33.0176C57.6029 32.7656 57.7446 32.4237 57.7446 32.0673C57.7446 31.7108 57.6029 31.369 57.3509 31.1169C57.0989 30.8649 56.757 30.7233 56.4005 30.7233Z"
      fill="#0B3251"
    />
    <path
      d="M60.0536 90.0874C60.0536 90.8407 60.3528 91.5631 60.8855 92.0958C61.4182 92.6285 62.1406 92.9277 62.8939 92.9277C63.6472 92.9277 64.3697 92.6285 64.9023 92.0958C65.435 91.5631 65.7342 90.8407 65.7342 90.0874C65.7342 89.3341 65.435 88.6116 64.9023 88.079C64.3697 87.5463 63.6472 87.2471 62.8939 87.2471C62.1406 87.2471 61.4182 87.5463 60.8855 88.079C60.3528 88.6116 60.0536 89.3341 60.0536 90.0874Z"
      fill="white"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.177 80.5224C48.177 80.823 48.1177 81.1207 48.0026 81.3985C47.8875 81.6762 47.7188 81.9286 47.5062 82.1411C47.2935 82.3537 47.0411 82.5222 46.7633 82.6372C46.4855 82.7521 46.1877 82.8112 45.887 82.811H3.2912C2.99044 82.8114 2.69256 82.7524 2.41459 82.6375C2.13662 82.5227 1.88402 82.3541 1.67123 82.1416C1.45844 81.929 1.28963 81.6766 1.17446 81.3988C1.05928 81.121 1 80.8231 1 80.5224V55.3345C1 55.0337 1.05927 54.7358 1.17443 54.4579C1.28959 54.18 1.45838 53.9275 1.67115 53.7149C1.88393 53.5022 2.13652 53.3336 2.41449 53.2186C2.69247 53.1036 2.99038 53.0444 3.2912 53.0446H45.887C46.4944 53.0446 47.0768 53.2859 47.5063 53.7153C47.9357 54.1448 48.177 54.7272 48.177 55.3345V66.7829L55.6419 75.1809C55.7889 75.3458 55.8851 75.5496 55.9188 75.7678C55.9525 75.9861 55.9223 76.2094 55.8319 76.4109C55.7415 76.6124 55.5948 76.7835 55.4093 76.9034C55.2239 77.0233 55.0077 77.087 54.7869 77.0869H48.177V80.5224Z"
      fill="white"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.2321 62.1994H7.23215"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.2321 68.1994H7.23215"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2321 74.1994H7.23215"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.0056 53.7379C77.0056 54.3907 77.2474 55.0168 77.6779 55.4784C78.1083 55.9401 78.6922 56.1994 79.301 56.1994H124.937C125.546 56.1994 126.129 55.9401 126.56 55.4784C126.99 55.0168 127.232 54.3907 127.232 53.7379V26.6609C127.232 26.0081 126.99 25.382 126.56 24.9204C126.129 24.4587 125.546 24.1994 124.937 24.1994H79.301C78.6922 24.1994 78.1083 24.4587 77.6779 24.9204C77.2474 25.382 77.0056 26.0081 77.0056 26.6609V32.8148V38.9686L69.5215 47.9943C69.3747 48.1716 69.2788 48.3907 69.2453 48.6252C69.2119 48.8596 69.2423 49.0994 69.333 49.3157C69.4236 49.532 69.5706 49.7157 69.7563 49.8445C69.9419 49.9734 70.1584 50.042 70.3795 50.042H77.0056V53.7379Z"
      fill="white"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M121.232 33.1994H83.2321"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M121.232 40.1994H83.2321"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M103.232 47.1994H83.2321"
      stroke="#0B3251"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
